import { DataType } from "@/components/DataTable/Models";
import clsx from "clsx";
import useDataTableContext from "../../../../context/useDataTableContext";

const DataTableHeader = () => {
    const { state } = useDataTableContext();
    const { columns, readOnly, onFilterColumn } = state;

    return (
        <thead className="bg-primary-500 text-white font-bold">
            <tr>
                {columns.map((column, index) => {
                    if (readOnly && onFilterColumn && onFilterColumn(column)) return null;

                    return (
                        <th
                            key={index}
                            scope="col"
                            className={clsx([
                                "py-3 px-2.5 text-center",
                                "border-primary-600 border-t border-l",
                                "first:rounded-tl-lg last:rounded-tr-lg last:border-r",
                                column.dataType === DataType.BOOLEAN && "w-[80px]",
                            ])}
                        >
                            {column.value}
                        </th>
                    );
                })}

                {!readOnly && (
                    <th
                        className={clsx([
                            "py-3 px-2.5 text-center w-[160px]",
                            "border-primary-600 border-t border-l",
                            "first:rounded-tl-lg last:rounded-tr-lg last:border-r",
                        ])}
                    >
                        Actions
                    </th>
                )}
            </tr>
        </thead>
    );
};

export default DataTableHeader;
